import type { ComponentProps } from "react";

import { Skeleton } from "@/components/ui/skeleton";

const shimmerClassName = "from-gray-100 via-gray-200 to-gray-100";

const Shimmer = (props: ComponentProps<typeof Skeleton>) => (
  <Skeleton className={shimmerClassName} {...props} />
);

const PromptResponseBlockShimmer = () => (
  <div className="relative space-y-2 overflow-y-auto rounded-sm border border-gray-300 bg-white p-4">
    <Shimmer height="14px" width="70%" />
    <Shimmer height="14px" width="45%" />
    <Shimmer height="14px" width="88%" />
    <Shimmer height="14px" width="52%" />
  </div>
);

const ResponseBlockShimmer = () => (
  <div className="relative h-full min-h-[240px] overflow-y-auto rounded-sm border border-gray-300 bg-gray-100 p-4">
    <div className="flex h-full flex-col gap-4">
      <div className="space-y-2">
        <Shimmer height="14px" width="90%" />
        <Shimmer height="14px" width="100%" />
        <Shimmer height="14px" width="70%" />
      </div>
      <div className="space-y-2">
        <Shimmer height="14px" width="85%" />
        <Shimmer height="14px" width="60%" />
      </div>
    </div>
  </div>
);

export const RequestDisplayLoadingShimmer = () => (
  <div aria-hidden="true" className="flex min-h-0 flex-col gap-4 overflow-hidden pb-4">
    {/* Mirrors RequestInfoBlock outer card */}
    <div className="relative w-full rounded-md border border-gray-200 bg-white px-4 py-3 text-gray-700">
      <div className="absolute right-4 top-3">
        <Shimmer width="32px" height="32px" borderRadius="6px" />
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 pr-10">
          <div className="flex items-center gap-2">
            <Shimmer width="24px" height="24px" borderRadius="4px" />
            <Shimmer width="180px" height="18px" borderRadius="4px" />
          </div>
          <div className="h-5 w-px bg-gray-200" />
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <Shimmer width="72px" height="14px" borderRadius="3px" />
            <Shimmer width="56px" height="14px" borderRadius="3px" />
            <Shimmer width="88px" height="14px" borderRadius="3px" />
            <Shimmer width="64px" height="14px" borderRadius="3px" />
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-2 border-t border-gray-100 pt-2">
          <Shimmer width="140px" height="32px" borderRadius="6px" />
          <Shimmer width="132px" height="32px" borderRadius="6px" />
          <div className="ml-auto flex flex-wrap items-center gap-x-2 gap-y-1">
            <Shimmer width="56px" height="22px" borderRadius="4px" />
            <Shimmer width="72px" height="22px" borderRadius="4px" />
            <Shimmer width="64px" height="22px" borderRadius="4px" />
          </div>
        </div>
      </div>
    </div>

    {/* Mirrors RequestDisplayTemplateView two-column layout */}
    <div className="grid min-h-0 flex-1 grid-cols-1 gap-x-10 gap-y-6 overflow-hidden md:grid-cols-2">
      <div className="flex min-h-0 flex-col overflow-y-auto">
        <div className="mb-1 flex flex-row items-center pb-1">
          <div className="flex-1">
            <Shimmer width="120px" height="18px" borderRadius="4px" />
          </div>
          <Shimmer width="28px" height="28px" borderRadius="4px" />
        </div>
        <PromptResponseBlockShimmer />
      </div>
      <div className="flex min-h-0 flex-col overflow-y-auto">
        <div className="mb-1 flex flex-row items-center pb-1">
          <div className="flex-1">
            <Shimmer width="132px" height="18px" borderRadius="4px" />
          </div>
          <Shimmer width="28px" height="28px" borderRadius="4px" />
        </div>
        <ResponseBlockShimmer />
      </div>
    </div>
  </div>
);
